import { Component, Input, Inject } from "@angular/core";
import { HttpService } from "../../providers/http.service";
import { ENV } from "../../environments/environment-variables.token";
import { AuthService } from "src/providers/auth.service";
import { MenuService } from "src/providers/menu.service";
import { Router } from "@angular/router";
// import * as moment from 'moment';
/**
 * Generated class for the DefaultTable component.
 *
 *
 */

@Component({
	selector: "default-menu",
	templateUrl: "./default-menu.html",
	styleUrls: ["./default-menu.scss"],
	providers: [],
})
export class DefaultMenuComponent {
	@Input() toggleMenu: any;
	public menuItems: any;
	public generated = false;
	public menuG: any;
	constructor(
		private httpService: HttpService,
		private auth: AuthService,
		private router: Router,
		private menuService: MenuService,
		@Inject(ENV) public ENV: any
	) {
		console.log("Hello DefaultTableComponent Component");
		this.auth.me().then(res => {
			this.menuService.gernerateMenu();
		}).catch(e => {
			this.router.navigate(["/login"]);
		});
	}

	navGo(route, title, params = {}) {
    console.log(params);

		this.ENV.pageTitle = title;
		console.log("aaaaaa", this.ENV.pageTitle)

		this.closeMenu();
		this.router.navigate(["/pages" + route], params);
	}
	closeMenu() {
		this.ENV.toggleMenu = false;
	}

	logout() {
		this.auth.logout().then(() => {
			this.menuService.clearMenu();
			this.menuG = undefined;
			this.closeMenu();
			this.router.navigate(["/login"]);
		});
	}
}
